import { isSupplyType } from "src/util/allocations";
import { getGroupType } from "src/util/groupType";

export type IsTeamInsightsAvailableArgs = {
  /** Team insights gate (`enableTeamInsights`, auto-on while org design is on). */
  insightsEnabled: boolean;
  /** OD beta (`enableDemoODOptions`). The cross-functional toggle sits under this. */
  betaEnabled?: boolean;
  /** Cross-functional teams insight (`enableOrgInsights`). */
  crossFunctionalInsights?: boolean;
  team?:
    | {
        type?: string | null;
        isHidden?: boolean | null;
        isDeleted?: boolean | null;
      }
    | null
    | undefined;
  groupTypes?: Record<string, unknown> | null | undefined;
};

export const isTeamInsightsAvailableForTeam = ({
  insightsEnabled,
  betaEnabled = false,
  crossFunctionalInsights = false,
  team,
  groupTypes,
}: IsTeamInsightsAvailableArgs): boolean => {
  if (!insightsEnabled || !team?.type) {
    return false;
  }
  if (team.isHidden || team.isDeleted) {
    return false;
  }
  const groupType = getGroupType(team, groupTypes);
  if (isSupplyType(groupType)) {
    return true;
  }
  // TPP-2131: a cross-functional team gets the Insights tab only while that beta toggle is on.
  return (
    isDemandTeam(team, groupTypes) && betaEnabled && crossFunctionalInsights
  );
};

export const isDemandTeam = (
  team: { type?: string | null } | null | undefined,
  groupTypes: Record<string, unknown> | null | undefined
): boolean => Boolean(getGroupType(team, groupTypes)?.isDemand);

/** Supply teams get the full page. Demand teams stay on the people page. TPP-2131. */
export const isInsightsFullPage = ({
  team,
  groupTypes,
}: {
  team: { type?: string | null } | null | undefined;
  groupTypes: Record<string, unknown> | null | undefined;
}): boolean => !isDemandTeam(team, groupTypes);
